import BaseModel from "./base/baseModel";

export default class EstoqueModel extends BaseModel {
    id?: number = null;
    descricao: string = null;
    permiteVenda = true;
}